module.exports = __webpack_public_path__ + "static/Kaizen_Corp_SIC-4547df152f0de012b8a62a590b41b3c8.png";